var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4001 19.3644H8.60009C7.80009 19.3644 7.14409 18.7404 7.09609 17.9404L6.49609 6.79639H17.5121L16.9121 17.9404C16.8721 18.7404 16.2081 19.3644 15.4081 19.3644H15.4001Z",
    stroke: "#3284FF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4403 4.56562H13.5123C13.8883 4.56562 14.2003 4.83762 14.2563 5.20562L14.4963 6.79762H9.48828L9.68028 5.22162C9.72828 4.84562 10.0483 4.55762 10.4323 4.55762L10.4403 4.56562Z",
    stroke: "#3284FF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.80664H19",
    stroke: "#3284FF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0239 9.74905L10.1919 16.4851",
    stroke: "#3284FF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9761 9.74905L13.8081 16.4851",
    stroke: "#3284FF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIDelete);
export default __webpack_public_path__ + "static/media/i_delete.22411593acd02201e45404e1c61cc10a.svg";
export { ForwardRef as ReactComponent };